// extracted by mini-css-extract-plugin
export default {"wrap":"aaVP1","link":"eSR14","link-fill":"EtRcU","content":"Et24u","text-content":"IIAMy","body":"VxQpk","title":"hFeTT","image":"e60W9","full-width":"eWTcZ"};